import type React from 'react';

import { PageBody } from '../components/PageBody';

import { useTrackLoginOrJoinMethod } from './hooks/useTrackLoginOrJoinMethod';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useTrackLoginOrJoinMethod();

	return <PageBody />;
};
